module.exports = __webpack_public_path__ + "static/media/UltraThin.d803b5bd.pdf";